import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRight,
  faArrowTrendUp,
} from "@fortawesome/free-solid-svg-icons";
import { motion } from "framer-motion";
import styles from "./HomeDiscountSection.module.css";
import { getDiscountedProducts } from "../../service/product";
import { useCart } from "../../context/CartContext";
import CartSidebar from "../CartSidebar";
import { Modal, ModalBody } from "react-bootstrap";
import LoginModal from "../login";
import HomeDicountSectionCard from "./HomeDicountSectionCard";

const HomeDiscountSection = () => {
  const [featuredDiscounts, setFeaturedDiscounts] = useState<any>([]);
  const fetchProducts = async () => {
    try {
      const params = {
        pageNumber: 1,
        pageSize: 6,
      };
      const data = await getDiscountedProducts(params);
      if (data && data.data) {
        setFeaturedDiscounts(data.data);

        // Extract unique series for filter options
      }
    } catch (err: any) {
      console.log(err.message || "Failed to load products");
    }
  };
  const [isCartOpen, setIsCartOpen] = useState(false);
  const { addToCart, cart, setCart } = useCart();

  const handleUpdateQuantity = (id: string, quantity: number) => {
    setCart(
      cart.map((item) =>
        item.id === id ? { ...item, quantity: Math.max(1, quantity) } : item
      )
    );
  };
  const [showLoginModal, setShowLoginModal] = useState(false);

  useEffect(() => {
    fetchProducts();
  }, []);
  return (
    <>
      <section className={styles.discountSection}>
        <div className={styles.container}>
          {/* Section Header */}
          <div className={styles.sectionHeader}>
            <div className={styles.titleContainer}>
              <h2 className={styles.sectionTitle}>
                {/* <FontAwesomeIcon icon={faFire}  */}
                <FontAwesomeIcon
                  icon={faArrowTrendUp}
                  className={styles.titleIcon}
                />
                Hot Deals & Discounts
              </h2>
              <p className={styles.sectionSubtitle}>
                Limited time offers on premium furniture. Don't miss out!
              </p>
            </div>
            <Link to="/discounts" className={styles.viewAllButton}>
              View All Deals
              <FontAwesomeIcon
                icon={faArrowRight}
                className={styles.buttonIcon}
              />
            </Link>
          </div>

          {/* Discount Products Grid */}
          <div className={styles.productsGrid}>
            {featuredDiscounts.map((product: any, index: any) => (
              <HomeDicountSectionCard product={product} index={index} />
            ))}
          </div>

          {/* CTA Banner */}
          <motion.div
            className={styles.ctaBanner}
            initial={{ opacity: 0, y: 50, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            transition={{
              delay: 0.4,
              duration: 0.8,
              type: "spring",
              stiffness: 100,
              damping: 15,
            }}
            whileHover={{
              scale: 1.02,
              transition: { duration: 0.3 },
            }}
          >
            {/* Animated Background Elements */}
            <div className={styles.animatedBackground}>
              <div className={styles.floatingShape1}></div>
              <div className={styles.floatingShape2}></div>
              <div className={styles.floatingShape3}></div>
              <div className={styles.pulseRing}></div>
              <div className={styles.redGlow}></div>
            </div>

            {/* Main Content */}
            <div className={styles.ctaContent}>
              <motion.h3
                className={styles.ctaTitle}
                initial={{ opacity: 0, x: -30 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.6, duration: 0.6 }}
              >
                🔥 Hot Deals Waiting for You!
              </motion.h3>

              <motion.p
                className={styles.ctaText}
                initial={{ opacity: 0, x: -30 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.8, duration: 0.6 }}
              >
                Don't miss out on incredible savings! Explore hundreds of
                premium furniture pieces with massive discounts.
              </motion.p>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 1, duration: 0.5 }}
              >
                <Link to="/discounts" className={styles.ctaButton}>
                  <span>Shop All Discounts</span>
                  <motion.div
                    className={styles.buttonIconWrapper}
                    whileHover={{ x: 5 }}
                    transition={{ type: "spring", stiffness: 400, damping: 10 }}
                  >
                    <FontAwesomeIcon
                      icon={faArrowRight}
                      className={styles.buttonIcon}
                    />
                  </motion.div>
                </Link>
              </motion.div>
            </div>

            {/* Enhanced Visual Element */}
            <div className={styles.ctaVisual}>
              <motion.div
                className={styles.discountOrbit}
                animate={{ rotate: 360 }}
                transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
              >
                <div className={styles.orbitDot}></div>
                <div className={styles.orbitDot}></div>
                <div className={styles.orbitDot}></div>
              </motion.div>

              <motion.div
                className={styles.discountCircle}
                initial={{ scale: 0, rotate: -180 }}
                animate={{ scale: 1, rotate: 0 }}
                transition={{
                  delay: 0.5,
                  duration: 1,
                  type: "spring",
                  stiffness: 100,
                }}
                whileHover={{
                  scale: 1.1,
                  rotate: 5,
                  transition: { duration: 0.3 },
                }}
              >
                <motion.span
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: 0.8, duration: 0.5 }}
                  className={styles.discountLabel}
                >
                  UP TO
                </motion.span>

                <motion.span
                  className={styles.discountPercent}
                  initial={{ scale: 0 }}
                  animate={{ scale: 1 }}
                  transition={{
                    delay: 0.9,
                    duration: 0.6,
                    type: "spring",
                    stiffness: 200,
                  }}
                  whileHover={{ scale: 1.2 }}
                >
                  60%
                </motion.span>

                <motion.span
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: 1, duration: 0.5 }}
                  className={styles.discountLabel}
                >
                  OFF
                </motion.span>
              </motion.div>

              {/* Sparkle Effects */}
              <div className={styles.sparkleContainer}>
                <div className={styles.sparkle}></div>
                <div className={styles.sparkle}></div>
                <div className={styles.sparkle}></div>
                <div className={styles.sparkle}></div>
              </div>

              {/* Fire Emoji Animation */}
              <motion.div
                className={styles.fireEmoji}
                animate={{
                  scale: [1, 1.2, 1],
                  rotate: [0, -5, 5, 0],
                }}
                transition={{
                  duration: 2,
                  repeat: Infinity,
                  ease: "easeInOut",
                }}
              >
                🔥
              </motion.div>
            </div>

            {/* Countdown Timer */}
            <motion.div
              className={styles.countdownTimer}
              initial={{ opacity: 0, scale: 0 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: 1.2, duration: 0.5 }}
            >
              <div className={styles.timerText}>Sale Ends In:</div>
              <div className={styles.timerUnits}>
                <span className={styles.timerUnit}>24H</span>
                <span className={styles.timerUnit}>60M</span>
                <span className={styles.timerUnit}>30S</span>
              </div>
            </motion.div>

            {/* Ribbon Corner */}
            <div className={styles.cornerRibbon}>
              <span>LIMITED TIME</span>
            </div>
          </motion.div>
        </div>
      </section>

      <CartSidebar
        isOpen={isCartOpen}
        onClose={() => setIsCartOpen(false)}
        cart={cart}
        onUpdateQuantity={handleUpdateQuantity}
      />
      {showLoginModal && (
        <Modal show={showLoginModal} onHide={() => setShowLoginModal(false)}>
          <ModalBody style={{ padding: "0px", margin: "0px" }}>
            <LoginModal isStandalone={true} />
          </ModalBody>
        </Modal>
      )}
    </>
  );
};

export default HomeDiscountSection;
